import { red } from '@mui/material/colors';
import { createTheme } from '@mui/material/styles';

// A custom theme for this app
const theme = createTheme({
  palette: {
    primary: {
      main: '#0F2A4A',
    },
    secondary: {
      main: '#3066B0',
    },
    error: {
      main: red.A400,
    },
  },
});

export default theme;
